import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a2eb64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-bar-layout-wrapper" }
const _hoisted_2 = { class: "body-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("专利")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提醒")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("我的")

import { useRouter, useRoute } from "vue-router";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionBarLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const activeBar = ref<any>(route.name);

router.afterEach((route) => {
  activeBar.value = route.name;
});


function navTo(name: string) {
  router.push({ name });
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_VanTabbarItem = _resolveComponent("VanTabbarItem")!
  const _component_VanTabbar = _resolveComponent("VanTabbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_VanTabbar, {
      modelValue: activeBar.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeBar).value = $event)),
      class: "action-bar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanTabbarItem, {
          name: "patent",
          icon: activeBar.value==='patent'?'wap-home':'wap-home-o',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (navTo('patent')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["icon"]),
        _createVNode(_component_VanTabbarItem, {
          name: "add-patent",
          icon: activeBar.value==='add-patent'?'add':'add-o',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (navTo('add-patent')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["icon"]),
        _createVNode(_component_VanTabbarItem, {
          name: "message",
          icon: activeBar.value==='message'?'chat':'chat-o',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (navTo('message')))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["icon"]),
        _createVNode(_component_VanTabbarItem, {
          name: "user-manager",
          icon: activeBar.value==='user-manager'?'manager':'manager-o',
          onClick: _cache[3] || (_cache[3] = ($event: any) => (navTo('user-manager')))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})